<template>
  <div>
    <el-card class="mat12">
      <el-row>
        <el-col :span="24" class="padding-tb10 flex_class ">
          <h4 class="flex_shrink">人员工资：</h4>
          <span class="ellipsis" :title="dataDesc.proWages.staffWage + ' 元/小时'">{{dataDesc.proWages.staffWage ? dataDesc.proWages.staffWage:''}} 元/小时</span>
        </el-col>
          <el-col :span="24" class="padding-tb10  ">
          <h4 class="flex_shrink">备注：</h4>
          <span class="" :title="dataDesc.proWages.note">{{dataDesc.proWages.note }}</span>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CardProjectWages',
  props: {
    dataDesc: {
      type: Object,
      default: {}
    }
  }

}
</script>

<style lang="scss" scoped>

</style>
